import modalStore from '@client/store/modalStore';
import { ModalStore } from '@client/store/modalStore';
import { createModalContainer } from '@client/component/modal/Modal';
import { commonPlugins } from '@client/component/modal/plugins';
import { PluginNamespaceApi } from '@client/component/modal/modalPlugin';
import { haewaoLoginPlugin } from './login';
import { stockPlugin } from './stock';
import { guidePlugin } from './guide';

const haewaoPlugins = {
    login: haewaoLoginPlugin,
    stock: stockPlugin,
    guide: guidePlugin,
} as const;

declare module '@client/store/modalStore' {
    interface ModalStore {
        haewao: PluginNamespaceApi<typeof haewaoPlugins>;
    }
}

modalStore.addNamespace('haewao', haewaoPlugins);

/**
 * 해와오 전용 ModalContainer
 * - commonPlugins + haewaoPlugins 모두 처리
 * - Layout에서 사용
 */
export const HaewaoModalContainer = createModalContainer({
    ...commonPlugins,
    ...haewaoPlugins,
});
